import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { changeDeliveryAddress } from "@redux"
import classes from "./CdsamAddressesFooter.module.scss"
import clsx from "clsx"

const CdsamAddressesFooter = (props) => {
  const {
    selectedAddress,
    setOpenMapAddressModal
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const handleSelect = () => {
    if (!selectedAddress._id) return

    dispatch(
      changeDeliveryAddress(selectedAddress)
    )

    setOpenMapAddressModal(false)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <Button
        color="success"
        disabled={!selectedAddress?._id}
        onClick={handleSelect}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("انتخاب")}
      </Button>

      <Button
        onClick={() => setOpenMapAddressModal(false)}
        color="danger"
      >
        {t("بستن")}
      </Button>
    </div>
  )
}

export default CdsamAddressesFooter